import { useSelector } from 'react-redux';
import useUser from '../../../user';
import { auth } from '../../../../firebase';

const useChangeEmail = () => {
  const { changeEmail } = useUser();
  const { user } = useSelector((state) => state.User);

  const changeEmailAddress = async ({ data }) => {
    if (
      !data.email ||
      auth.currentUser.email?.trim().toLowerCase() !==
        data?.email?.trim().toLowerCase()
    ) {
      await changeEmail(data?.email || user.email);
    }

    return {
      user: data
    };
  };

  return {
    changeEmailAddress
  };
};

export default useChangeEmail;
